<template>
  <div class="hx-shadow-contianer">
    <h1 class="title">页面走丢了~</h1>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  }
};
</script>

<style lang="less" scoped>
.title {
  font-size: 32px;
  color: #ff0000;
  text-align: center;
  line-height: 100px;
}
</style>
